import * as types from './types';

const initialState = {
  translationCategories: {},
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_TRANSLATION_CATEGORY:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
